module.exports = __webpack_public_path__ + "img/six million sasquatch.a74617bd.png";